import { useCoursesLoaderData } from "./coursesLoader.ts";

export default function useInstitutionProgram() {
  const { currentTerm } = useCoursesLoaderData();
  const program = currentTerm?.institutionProgram;
  return { program, isEquitableAccessProgram: program === "equitable_access" };
}
